// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"1067b8e5","453":"77aef9b5"}[chunkId] + ".chunk.js";
};